import React, { memo } from 'react'
import { ILoad } from 'apps/fleet-planner/types'
import { isExternalDriver } from 'apps/fleet-planner/utils/isExternal'
import { Avatar } from 'transfix-ui'

export const LoadDrivers = memo<{ load: ILoad }>(({ load }) => {
  const { drivers = [] } = load || {}
  return (
    <div className='mr4'>
      {drivers.map(driver => {
        if (isExternalDriver(driver)) {
          return (
            <Avatar
              colorClassName='input'
              tooltipClassName='tc'
              key={driver?.name}
              name={driver?.name}
              details='Driver info imported from Transfix'
            />
          )
        }
        return (
          <Avatar tooltipClassName='tc' key={driver?.name} name={driver?.name} details='Driver' />
        )
      })}
      {!drivers.length && (
        <Avatar tooltipClassName='tc' tooltipName='Unassigned' details='Driver' />
      )}
    </div>
  )
})
